import React from 'react';
import { PropTypes } from 'prop-types';
import TDModal from '../shared/td-modal';
import { formatDate } from '../../utility/dates';
import ProviderSearchTable from './provider-search-table';

const AddProviderModal = (props, context) => {
  const { isModalOpen, incentiveCost } = props;
  const { max_number_providers, start_date, end_date, providers_count } = (incentiveCost || {});
  const canAddProviders = (providers_count || 0) < max_number_providers;
  const { clearIncentiveCost } = context;

  return (
    <TDModal title="Assign Providers" isOpen={isModalOpen} notifyOfClose={clearIncentiveCost}>
      <div>
        Start Date: {formatDate(start_date)}<br />
        End Date: {formatDate(end_date)} <br />
        Number Providers Assigned: {providers_count || 0} / {max_number_providers}
      </div>
      <div className="table-wrapper">
        <ProviderSearchTable incentiveCost={incentiveCost} canAddProviders={canAddProviders} />
      </div>
    </TDModal>
  );
};

AddProviderModal.propTypes = {
  isModalOpen:   PropTypes.bool,
  incentiveCost: PropTypes.shape({ provider_incentive_cost_id: PropTypes.number })
};

AddProviderModal.contextTypes = {
  providerIncentiveCostStore: PropTypes.object,
  clearIncentiveCost:         PropTypes.func
};

export default AddProviderModal;
